import { api } from '../../lib/apiClient';

export const billingKeys = {
  subscription: ['billing-subscription'],
  setup: ['billing-setup'],
  usage: ['billing-usage'],
};

/** Current org's subscription (org-level billing — one live sub per org). */
export const getBillingSubscription = async () =>
  (await api.get('/billing/subscription')).data;

/** SetupIntent client secret + pending plan for the card step. */
export const startBillingSetup = async () => (await api.post('/billing/setup')).data;

/**
 * Change plan/cycle. Pre-activation: swaps the pending checkout plan. Live:
 * upgrades apply immediately (prorated charge now), downgrades at period end.
 */
export const changeBillingPlan = async (body) => (await api.patch('/billing/plan', body)).data;

/** Usage vs plan limits: storage bytes, seats, workspaces. Owner-only. */
export const getBillingUsage = async () => (await api.get('/billing/usage')).data;

/** Undo a scheduled downgrade — keep the current plan. */
export const cancelScheduledPlanChange = async () =>
  (await api.delete('/billing/plan/scheduled')).data;

/** Finish signup billing: starts the provider trial against the saved card. */
export const activateBilling = async (body) => (await api.post('/billing/activate', body)).data;

/** Schedule cancellation at the end of the current billing period. */
export const cancelBillingSubscription = async () => (await api.post('/billing/cancel')).data;

/** Undo a pending cancel-at-period-end. */
export const resumeBillingSubscription = async () => (await api.post('/billing/resume')).data;

export const changeExtraSeats = async (extraSeats) => (await api.patch('/billing/seats', { extraSeats })).data;
